(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mcps-sdk-js"] = factory();
	else
		root["mcps-sdk-js"] = factory();
})(window, function() {
return 